import generate from 'utils/generate';

const authentication = {
  getToken,
  getDecodedJwttoken,
  setJwttokenToStorage,
  cekDataStorages,
  decryptData,
  getSessionStorages,
  setSessionStorages,
  deleteSessionStorages,
  deleteAllSession
};

var engine = require('store/src/store-engine');
var storages = [
  require('store/storages/sessionStorage'),
  require('store/storages/cookieStorage')
];
var plugins = [
  require('store/plugins/defaults'),
];
var CryptoJS = require('crypto-js');
var jwtDecode = require('jwt-decode');
var store = engine.createStore(storages, plugins);

function decryptData(name){
  var dataStorage = store.get(name);
  var bytes = CryptoJS.AES.decrypt(dataStorage.page, generate.SHA256());
  var dataJSON = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return dataJSON;
}

function getToken(name){
  let data = decryptData(name);
  let token = '';
  if(data){
    token = data.token;
    return token;
  }else{
    return false;
  }
}

function getDecodedJwttoken(token){
  var decoded = jwtDecode(token);
  return decoded;
}

function setJwttokenToStorage(data, name){
  var dataToStore = CryptoJS.AES.encrypt(JSON.stringify(data), generate.SHA256());
  var stringDataToStore = dataToStore.toString();
  store.set(name, {
    page: stringDataToStore
  });
}

function cekDataStorages(name){
  if(store.get(name)){ return true; }
  return false;
}

function getSessionStorages(name){
  var data = store.get(name);
  return data;
}

function setSessionStorages(name, data){
  store.set(name, data);
}

function deleteSessionStorages(name){
  store.remove(name);
}

function deleteAllSession() {
  store.clearAll();
}

export default authentication;
